import React, { useCallback } from 'react'
import { PanelHeader } from '../../../../components/PanelHeader/PanelHeader';
import { PanelFooter } from '../../../../components/PanelFooter/PanelFooter';
import { MessageBar, MessageBarType, Panel, PanelType } from '@fluentui/react';
import { IOpenPanel } from '../../../../interfaces/base/IPanel';
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { UseRosterEliminar } from './UseRosterEliminar';
import { ProgressBarLoading } from '../../../../components/ProgressBarLoading/ProgressBarLoading';
import { IRoster } from '../../../../interfaces/IRoster';


export interface IPanelRosterEliminar extends IOpenPanel {
    rosterData: IRoster
}

const PanelRosterEliminar = (props: IPanelRosterEliminar) => {

    const { request, deleteRoster, loading, reset, mensaje, status } = UseRosterEliminar(props)

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="delete"
                    textHeader={`Rosters`}
                    subTextHeader={`Eliminar roster`}
                />
            </>
        ),
        []
    );

    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Eliminar"
                    onClick={deleteRoster}
                    onDismiss={reset}
                />
            </>
        ), [request]
    );

    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={onRenderHeader}
                onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : undefined}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={reset}
            >
                <div hidden={mensaje == ""}>
                    <MessageBarResponse
                        objetoResponse={{ codigo: status, mensaje: mensaje }}
                        close={true}
                    />
                </div>
                <div hidden={!loading}>
                    <ProgressBarLoading ></ProgressBarLoading>
                </div>
                <div hidden={loading || mensaje != ""}>
                    <MessageBar
                        delayedRender={false}
                        messageBarType={MessageBarType.severeWarning}
                    >
                        ¿Seguro que quieres eliminar el roster:<strong> {props.rosterData?.codigo}</strong>?
                    </MessageBar>
                </div>
            </Panel>
        </>
    )
}

export { PanelRosterEliminar }